import PropTypes from 'prop-types';
import React from 'react';

const AleloHi = '/messages/alelo-hi.png';

export const MessageHiIcon = (props) => {
  return (
    <div className="message-line" data-testid="message-hi">
      <div
        className="message-receive message-receive__no-background"
        id={`msg-${props.message.id}`}
        data-aut-test="message-hi-icon"
      >
        <div className="message-div">
          <img src={AleloHi} alt="Oi da Alelo" />
        </div>
      </div>
    </div>
  );
};

MessageHiIcon.propTypes = {
  message: PropTypes.object
};
